import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { LayoutTokens } from '@vds-tokens/layout';
import { VDSManager } from '@vds/utilities';

import OnboardingLanding from './components/onboarding/onboardingLanding';
import './config/config';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import CourseContentPage from './views/CourseContentPage';
import GrantsPageComponent from './views/Grants'
import Header from './layout/Header';
import Footer from './layout/Footer';
import { useEffect } from 'react';
import { pageLoadStarted } from './common/Analytics/GAWrapper.jsx';
import i18n from './components/React-i18Next/I18next.js';
import { Helmet } from 'react-helmet';
import ScrollTo from './components/common/ScrollTo.jsx';
import { Loader } from '@vds/loaders';
import App from './App.jsx';
import EventDetailsPage from './views/EventDetailsPage/EventDetailsPge.jsx';
import OneSearch from './views/OneSearch.jsx';


import { Client as Styletron } from "styletron-engine-monolithic";
import { Provider as StyletronProvider } from "styletron-react";
import { LightTheme, BaseProvider, styled } from "baseui";
import AskAIPage from './views/AI-Search/AskAIPage/AskAIPage.jsx';
import SearchResultsComponent from './views/AI-Search/ClassicSearch/Search-Results/searchResults.jsx';

const engine = new Styletron();
const LandingPage = lazy(() => import('./views/LandingPage.jsx')); 
const OnboardingPage = lazy(() => import('./views/onboarding/OnboardingPage.jsx')); 
const Privacy = lazy(() => import('./views/privacy/privacy.jsx')); 
const GrantsWrapperComponent = lazy(() => import('./views/GrantsWrapperComponent.jsx')); 
const Results = lazy(() => import('./components/results/Results.jsx')); 
const CategoryLandingComponent = lazy(() => import('./components/Category/CategoryLandingComponent.jsx'));
const CourseContentWrapperComponent = lazy(() => import('./views/CourseContentWrapperComponent.jsx'));
const Networking = lazy(() => import('./components/Networking.jsx'));
const SuperbowlGrantDetailsLanding = lazy(() => import('./components/specialGrants/SuperBowl/superBowl.jsx'));
const CourseDetailsPage = lazy(() => import('./views/CourseDetailsPage/CourseDetailsPage.jsx'));

const cssRoot = document.querySelector(':root');
// set css variable
for (let tokens in LayoutTokens.space) {
  cssRoot?.style?.setProperty(
    '--space' + tokens,
    LayoutTokens.space[tokens].value
  );
  console.log(tokens);
}
const getPageTitle = () =>{
  let entries = {
    '/onboarding': 'Onboarding',
    '/account/settings': 'Account Settings',
    '/networking': 'Networking',
    '/grants': 'Grants',
    '/results/branding': 'Branding',
    '/results/funding': 'Funding',
    '/results/onlinemarketing': 'Online Marketing',
    '/results/winningcustomers': 'Winning Customers',
    '/results/websitedesign': 'Website Design',
    '/results/legalessentials': 'Legalessentials',
    '/results/operations': 'Operations',
    '/results/socialmedia': 'Socialmedia',
    '/results/strategy': 'Strategy',
    '/results/cybersecurity': 'Cybersecurity',
    '/results/managingmoney':'Wellness',
    '/results/managingmoney':'Managing Money',
    '/category/offers': 'Offers',
    '/category/courses': 'Courses',
    '/category/events': 'Events',
    '/category/quicktips': 'Quick Tips',
    '/':'Landing',
    '/super-bowl' : 'Super Bowl - Grant'
  };
  let pageTitle = "Verizon Small Business Digital Ready";
console.log("entries[location.pathname",entries[location.pathname])
  if (entries[location.pathname]) {
    pageTitle = pageTitle + ' - ' + entries[location.pathname];
  }
 
  return pageTitle;
}
console.log("useeffect inside app.jsx")
const location = window.location;
const path = location.pathname;
const storel = window.localStorage;
let url = '';
let prevUrl = '';
console.log("Language",localStorage.getItem("lng"))
url = storel.getItem('url');
storel.setItem('prevUrl', url);
if (!path.startsWith('/onboarding') && !path.startsWith('/es/onboarding')) {
    storel.setItem('url', path);
}
console.log("Url", storel.getItem("prevUrl"))
console.log("Url current", storel.getItem("url"))
const root = ReactDOM.createRoot(document.getElementById('root'));
const env = global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2'  : '';

const normalizeLanguageFromPath = (pathname = window.location.pathname, storage = window.localStorage) => {
  if (!storage) return 'en';

  const normalizedPath = (pathname || '').replace(/\/+$/, '') || '/';
  const isSpanishPath = normalizedPath === '/es' || normalizedPath.startsWith('/es/');
  const nextLanguage = isSpanishPath ? 'es' : 'en';

  if ((storage.getItem('lng') || 'en') !== nextLanguage) {
    storage.setItem('lng', nextLanguage);
  }

  return nextLanguage;
};

const currentLanguage = normalizeLanguageFromPath(window.location.pathname, window.localStorage);

/* const aemCSSFiles = [
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/common/fonts.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/common/common.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/common/icons.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/common/theme.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/common/typography.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/offerCategory.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/categoryOffers.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/swiper-bundle.min.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/swiper.css`,
  `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}/css/common/vds-icons.css`

]; */

root.render(
  <>
    <Provider store={store}>
    <Header/>
    <ScrollTo/>
    <Helmet htmlAttributes={{ lang: localStorage.getItem("lng") ? localStorage.getItem("lng") : "en" }} />
    {/* <Helmet>
          {aemCSSFiles.map((file, _) => (<link key={file} href={file} rel="stylesheet" type="text/css"></link>))}
    </Helmet> */}
    <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />
    {/* {aemCSSFiles.map((file, _) => (<link key={file} href={file} rel="stylesheet" type="text/css"></link>))} */}
      <VDSManager />
      <StyletronProvider value={engine}>
      <BaseProvider theme={LightTheme}>
      <BrowserRouter basename={currentLanguage === 'es' ? 'es' : ''} >
        <Suspense fallback={<Loader fullscreen={true} active={true} surface="light"/>}>
          <Routes>
            <Route path="/" element={<App />}>
            <Route path="/" element={<LandingPage />}></Route>
            <Route path="/welcome" element={<LandingPage />}></Route>
            <Route path="/onboarding" element={<OnboardingPage />}></Route>
            <Route exact path="/onboarding/:userTypeParams" element={<OnboardingPage />}></Route>
            <Route path="/privacy/your-privacy-choices" element={<Privacy />}></Route>
            <Route path="/grants" element={<GrantsWrapperComponent />}></Route>
            <Route path="/results/:topicType/*" element={<Results/>} ></Route>
            <Route path="/partner-:partnerId" element={<App />} />
            <Route exact path="/category/:categoryType/:filterType/*" element={<CategoryLandingComponent/>} />
            <Route exact path="/category/:categoryType/*" element={<CategoryLandingComponent/>} />
            <Route path="/course-details/:courseId/:partnerSuffix" element={<CourseContentWrapperComponent />}></Route>
            <Route path="/course-details/:courseId/*"  element={<CourseContentWrapperComponent />}></Route>
            <Route path="/learning-details/:courseId/:partnerSuffix" element={<CourseContentWrapperComponent/>}></Route>
            <Route path="/learning-details/:courseId/*" element={<CourseContentWrapperComponent/>}></Route>
            <Route path="/networking" element={<Networking />}></Route>
            <Route path="/super-bowl" element={<SuperbowlGrantDetailsLanding />}></Route>
            <Route path="/oneSearch" element={<OneSearch/>}></Route>
             <Route path="/askai/:partnerSuffix" element={<AskAIPage />}></Route>
            <Route path="/askai/*" element={<AskAIPage />}></Route>
            <Route path="/askai" element={<AskAIPage />}></Route>
            <Route path="/classic-search" element={<SearchResultsComponent/>}></Route>
            <Route path="*" element={<LandingPage />}></Route>
            </Route>
            <Route path="*" element={<App />}></Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
      </BaseProvider>
      </StyletronProvider>
      {/* <StyletronProvider value={engine}>
      <BaseProvider theme={LightTheme}>
      <BrowserRouter>
        <Suspense fallback={<Loader fullscreen={true} active={true} surface="light"/>}>
            <Routes> 
              <Route path="*" element={<App />}></Route>
            </Routes>
          </Suspense>
      </BrowserRouter>
      </BaseProvider>
      </StyletronProvider> */}
      
    </Provider>
    <Footer/>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//console.log("Inside root")
//pageLoadStarted(language,"hi","welcome");
